/**
 * Contains general application-wide constants.
 */
import {ConnectionIndicatorConfig} from '../../components/connection-indicator/connection-indicator.component';
import {TILE_TYPE} from '../../services/tile.service';

/**
 * Constants
 */
export const constants = {
    api: {
        urls: {
            auth: 'https://live.innogy.2ndlab.de/auth',
            auth_wla: 'https://iona-dev.wla-backend.de/auth',
            base: 'https://api.n2g-iona.net/v2/'
        },
        routes: {
            instantaneous: 'instantaneous',
            phase: 'instantaneous/phases',
            homeState: {
                current: 'home_state/current',
                config: 'home_state/config'
            },
            power: 'power',
            disaggregation: {
                history: 'disaggregation/history'
            },
            electricity: {
                consumption: {
                    this: 'electricity/consumption',
                    compare: 'electricity/consumption/compare',
                    compareMonth: 'electricity/consumption/compare/month',
                },
                bill: {
                    prediction: 'electricity/bill/prediction'
                }
            },
            initialization: 'initialisation',
            profile: {
                this: 'profile',
                attributes: 'profile/attributes'
            },
            registration: {
                email: 'registration/email',
                setPassword: 'registration/setpassword',
                resetPassword: 'registration/resetpassword',
                voucher: 'registration/voucher',
                noGateway: 'registration/no-gateway',
                onboard: 'registration/onboard',
                optIn: 'registration/opt-in',
                online: 'registration/online',
                model: 'registration/model'
            },
            meter: {
                status: 'meter/status',
                connect: 'meter/connect'
            },
            nilm: {
                status: 'nilm/status'
            },
            plug: {
                relay: 'plug/relay'
            },
            configuration: {
                dashboard: 'configuration/dashboard'
            },
            iona: {
                happyHour: {
                    this: 'iona/happyhour',
                    participation: 'iona/happyhour/participation',
                    schedule: 'iona/happyhour/schedule',
                    consumption: {
                        electricity: {
                            days: 'iona/happyhour/consumption/electricity/days',
                            weeks: 'iona/happyhour/consumption/electricity/weeks',
                            months: 'iona/happyhour/consumption/electricity/months',
                            years: 'iona/happyhour/consumption/electricity/years',
                        }
                    }
                },
                usergroups: {
                    this: 'iona/usergroups'
                }
            },
            smartbridge: {
                reportMode: {
                    realTime: 'smartbridge/report-mode/real-time',
                    settings: 'smartbridge/report-mode/settings',
                }
            },
            meterreader: {
                this: 'meterreader',
                status: 'meterreader/status',
            },
            firmware: {
                this: 'firmware'
            }
        },
    },
    assets: {
        demo: 'assets/data/demo/'
    },
    demo: {
        files: {
            bill_prediction: 'bill_prediction',
            bill_prediction_test: 'bill_prediction_test',
            consumption: 'consumption',
            consumption_days: 'consumption_days',
            consumption_hours: 'consumption_hours',
            consumption_hours_last_week: 'consumption_hours_last_week',
            consumption_months: 'consumption_months',
            disagregation_history: 'disagregation_history',
            initialization: 'initialisation',
            initialization_test: 'initialisation_test',
            home_state_current: 'home_state_current',
            home_state_config: 'home_state_config',
            nilm_status: 'nilm_status',
            nilm_status_test: 'nilm_status_test',
            power_10_seconds: 'power_10_seconds',
            power_15_minutes: 'power_15_minutes',
            power_1_minute: 'power_1_minute',
            power_5_seconds: 'power_5_seconds',
            power_5_seconds_last_10_minutes: 'power_5_seconds_last_10_minutes',
            profile: 'profile',
            profile_attributes: 'profile_attributes',
            instantaneous: 'instantaneous',
            instantaneous_phases: 'instantaneous_phases',
            instantaneous_phases_history: 'instantaneous_phases_history',
            meter_status: 'meter_status',
            registration_online: 'registration_online',
            registration_online_test: 'registration_online_test',
            registration_model: 'registration_model',
            registration_model_test: 'registration_model_test',
            plug_relay: 'plug_relay',
            plug_relay_test: 'plug_relay_test',
        }
    },
    application: {
        states: {
            none: 'none',
            demo: 'demo',
            live: 'live'
        },
        storage: {
            keys: {
                app_mode: 'app-mode',
                app_expire: 'app-expire',
                providername: 'user-provider'
            }
        },
        devices: {
            plug: 'IONA4911',
            plug_optical: 'SPLR4911',
            box: 'IONA4910',
        }
    }
};


export const tileIds = {
    live: 'live',
    today: 'today',
    comparison: 'compare',
    appliances: 'appliances',
    meter: 'meter',
    finance: 'finance',
    consumptionAlert: 'consumption-alert',
    phaseChecker: 'phase-checker',
    powerChecker: 'power-checker'
};

export const ernaProviders =
    ['avacon', 'schleswig-holstein netz', 'bayernwerk netz', 'e.dis', 'opto'];

export const validVoucherPrefixes =
    ['igy', 'eon', 'edg', 'opto'];
